import axios from 'axios'
import qs from 'qs'

import errorHandle from './codeTip'

const CONTENT_TYPE_FORM = 'application/x-www-form-urlencoded; charset=UTF-8'
const CONTENT_TYPE_JSON = 'application/json; charset=UTF-8'

const ENV = process.env.VUE_APP_ENV

/**
 * loading: show loading
 * landingStatus: 登陆态,查询参数的形式
 * formType: change post methods content type
 * getQueryParameter: get methods change query parameter
 * errorTip: show error tip
 */
let options = {
  loading: false,
  landingStatus: true,
  formType: false,
  getQueryParameter: true,
  errorTip: true
}

const hideLoading = () => {
  if (options && options.loading) {
    Loading.hide()
  }
}

const service = axios.create({
  withCredentials: true
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
})

// request interceptor
service.interceptors.request.use(
  config => {
    options = { ...options, ...config.options }
    const userInfo = UserService.getUserInfo()
    if (options && options.loading) {
      Loading.show()
    }
    if (options && options.landingStatus) {
      const params = { ...userInfo, ...config.params }
      config.params = params
    }
    const type = config.method.toLowerCase()
    if (type === 'post') {
      config.headers.post['Content-Type'] = options.formType ? CONTENT_TYPE_FORM : CONTENT_TYPE_JSON
    }
    if (type === 'get' && options.getQueryParameter && config.params === undefined) {
      config.params = config.data
    }
    // token or authorization add
    return config
  },
  error => {
    hideLoading()
    console.error(error)
    if (options.errorTip) {
      errorHandle(error)
    }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    hideLoading()
    const res = response.data
    if (res.code !== 0) {
      if (options.errorTip) {
        console.error(res)
        errorHandle(res)
      }
      return Promise.reject(res)
    }
    return res.data
  },
  error => {
    hideLoading()
    console.error(error)
    if (options.errorTip) {
      errorHandle(error)
    }
    return Promise.reject(error)
  }
)

export default service
